// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._2XGpjJQ4MS0FLnplJquKkT {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n._1UQYekgxJ_6AyMmIdFzsB4 {\n  display: block;\n  width: 100%;\n  height: 100%;\n  color: '#212E59';\n}\n\n", "",{"version":3,"sources":["MonteCarloDartBoard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","file":"MonteCarloDartBoard.css","sourcesContent":[".container {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n.svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  color: '#212E59';\n}\n\n"]}]);
// Exports
exports.locals = {
	"container": "_2XGpjJQ4MS0FLnplJquKkT",
	"svg": "_1UQYekgxJ_6AyMmIdFzsB4"
};
module.exports = exports;
